import template from './shipment_batch.html';
import controller from './shipment_batch.controller';
import './shipment_batch.scss';

let shipmentBatchComponent = {
  restrict: 'E',
  template,
  controller
};

export default shipmentBatchComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/shipment_batch.component.js